import { render } from "./AllergiesTable.vue?vue&type=template&id=bf782bc0&scoped=true"
import script from "./AllergiesTable.vue?vue&type=script&lang=js"
export * from "./AllergiesTable.vue?vue&type=script&lang=js"

import "./AllergiesTable.vue?vue&type=style&index=0&id=bf782bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf782bc0"]])

export default __exports__